import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { isSameDay } from 'helpers/dates';
import { Calendar, Loading } from 'e4shared';
import { apiGet } from 'services';

export const Logins = ({ profileId }) => {
    const today = new Date();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [month, setMonth] = React.useState(today.getMonth());
    const [year, setYear] = React.useState(today.getFullYear());
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    React.useEffect(() => {
        const gotResponse = response => {
            setData(response);
            setLoading(false);
        };

        const qs = `?month=${month + 1}&year=${year}`;
        profileId && apiGet(`profile/${profileId}/logins${qs}`, guid, response => gotResponse(response));
    }, [guid, profileId, month, year]);

    if (loading) return <Loading />;

    const hasLogin = date => data.some(d => isSameDay(new Date(d), new Date(date)));

    const content = date => (
        <div className="text-center" style={{ width: '100%' }}>
            {hasLogin(date) && <i className="fa fa-lg fa-check-circle text-success" />}
        </div>
    );

    const moveMonth = (m, y) => {
        setMonth(m);
        setYear(y);
    };

    return (
        <div>
            <Calendar content={content} moveMonth={moveMonth} dayLength="short" />
        </div>
    );
};

export default Logins;
